import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/Home.vue'
import Layout from '@/components/Layout.vue';
import Models from '@/views/Models.vue';
import Contact from '@/views/Contact.vue';
import X25 from '@/views/x25.vue';
import BJ40 from '@/views/bj40.vue';
import D20 from '@/views/d20.vue';
import Prebooking from '@/views/prebooking.vue';

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    component: Layout,
      path: '/',
      meta: {
        private: true,
      },
      children: [
      {
        path: '/',
        name: 'Home',
        component: Home
      },
      {
        path: '/models',
        name: 'Models',
        component: Models
      },
      {
        path: '/contact',
        name: 'Contact',
        component: Contact
      },
      {
        path: '/x25',
        name: 'X25',
        component: X25
      },
      {
        path: '/bj40',
        name: 'BJ40',
        component: BJ40
      },
      {
        path: '/d20',
        name: 'D20',
        component: D20,
      },
      {
        path: '/booking',
        name: 'Booking',
        component: Prebooking,
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
